import {formatDimension} from "@spoferan/spoferan-ts-core";

export default {
    props: {

        width: {
            type: [String, Number],
            default: null
        },

        height: {
            type: [String, Number],
            default: null
        },

        minWidth: {
            type: [String, Number],
            default: null
        },

        minHeight: {
            type: [String, Number],
            default: null
        },

        maxWidth: {
            type: [String, Number],
            default: null
        },

        maxHeight: {
            type: [String, Number],
            default: null
        },
    },

    computed: {
        widthStyle() {
            if (!this.width) {
                return null;
            }

            return formatDimension(this.width)
        },

        maxWidthStyle() {
            if (!this.maxWidth) {
                return null;
            }

            return formatDimension(this.maxWidth)
        },

        minWidthStyle() {
            if (!this.minWidth) {
                return null;
            }

            return formatDimension(this.minWidth)
        },

        heightStyle() {
            if (!this.height) {
                return null;
            }

            return formatDimension(this.height)
        },

        maxHeightStyle() {
            if (!this.maxHeight) {
                return null;
            }

            return formatDimension(this.maxHeight)
        },

        minHeightStyle() {
            if (!this.minHeight) {
                return null;
            }

            return formatDimension(this.minHeight)
        }
    }
}
